import { getEnvironmentUrlApiV2 } from './getEnvironmentUrlApiV2';

export const getLibraryItems = (
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlApiV2>[0],
  searchTerms = '',
): Promise<unknown> => {
  const params = new URLSearchParams({
    pageNumber: '0',
    pageSize: '50',
  });
  if (searchTerms) {
    params.set('searchTerm', searchTerms);
  }
  return fetch(`${getEnvironmentUrlApiV2(environment)}videos?${params.toString()}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  }).then((res) => res.json());
};
